import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Exclamation = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      stroke={iconColor}
      strokeWidth="2"
      fill={iconColor}
      contentScriptType="text/ecmascript"
      contentStyleType="text/css"
      enableBackground="new 0 0 2048 2048"
      id="Layer_1"
      preserveAspectRatio="xMidYMid meet"
      version="1.1"
      viewBox="97.33300018310547 0 445.333984375 2048"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      zoomAndPan="magnify"
    >
      <title>{iconTitle}</title>
      <path d="M512,1376v224c0,17.333-6.333,32.333-19,45s-27.667,19-45,19H192c-17.333,0-32.333-6.333-45-19s-19-27.667-19-45v-224  c0-17.333,6.333-32.333,19-45s27.667-19,45-19h256c17.333,0,32.333,6.333,45,19S512,1358.667,512,1376z M542,320l-28,768  c-0.667,17.333-7.5,32.333-20.5,45s-28.167,19-45.5,19H192c-17.333,0-32.5-6.333-45.5-19s-19.833-27.667-20.5-45L98,320  c-0.667-17.333,5.167-32.333,17.5-45s27.167-19,44.5-19h320c17.333,0,32.167,6.333,44.5,19S542.667,302.667,542,320z" />
    </svg>
  );
};

Exclamation.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Exclamation.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Exclamation);
